import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock, Mail, Phone } from 'lucide-react';
import { Button } from '../ui/button';

export const FooterLanding = ({ onDemo }) => (
  <footer className="bg-forest-900 noise-overlay pt-20 sm:pt-28 pb-10 overflow-hidden" data-testid="landing-footer">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      {/* CTA final */}
      <div className="text-left max-w-3xl mb-20">
        <h2 className="font-display font-black text-bone text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight mb-6">
          Cumple la ley hoy mismo.<br />
          <span className="text-bone/50">Tu equipo ficha mañana.</span>
        </h2>
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
          <Button asChild size="lg" className="rounded-full bg-terracotta hover:bg-terracotta-hover text-white font-body-landing font-bold h-12 px-8 text-base group">
            <Link to="/registro" data-testid="footer-trial-btn">
              Empieza gratis 15 días
              <ArrowRight className="w-4 h-4 ml-1 transition-transform group-hover:translate-x-1" />
            </Link>
          </Button>
          <Button size="lg" onClick={onDemo} variant="outline" className="rounded-full border-bone/25 text-bone hover:bg-bone/10 hover:text-bone font-body-landing font-bold h-12 px-8 text-base bg-transparent" data-testid="footer-demo-btn">
            Ver demo · Te llamamos
          </Button>
        </div>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 border-t border-bone/10 pt-12 mb-16">
        <div>
          <div className="flex items-center gap-2.5 mb-4">
            <span className="w-8 h-8 rounded-lg bg-bone flex items-center justify-center">
              <Clock className="w-4 h-4 text-forest-900" />
            </span>
            <span className="font-display font-bold text-bone">GestionaEmpleados</span>
          </div>
          <p className="font-body-landing text-sm text-bone/50 leading-relaxed max-w-xs">
            Control horario para empresas españolas. Simple para tus empleados, tranquilo para ti.
          </p>
        </div>
        <div>
          <p className="font-body-landing font-bold text-bone/80 text-sm mb-4">Contacto</p>
          <ul className="space-y-3 font-body-landing text-sm text-bone/60">
            <li>
              <a href="mailto:comercial@gestionaempleados.com" className="hover:text-bone transition-colors inline-flex items-start gap-2" data-testid="footer-email-link">
                <Mail className="w-4 h-4 mt-0.5 shrink-0 text-terracotta" />
                <span className="break-all">comercial@gestionaempleados.com</span>
              </a>
            </li>
            <li>
              <a href="tel:+34680292427" className="hover:text-bone transition-colors inline-flex items-center gap-2" data-testid="footer-phone-link">
                <Phone className="w-4 h-4 shrink-0 text-terracotta" />
                <span>680 292 427</span>
              </a>
            </li>
            <li className="text-bone/40 text-xs pt-1">L-V · 9:00 - 18:00 (Península)</li>
          </ul>
        </div>
        <div>
          <p className="font-body-landing font-bold text-bone/80 text-sm mb-4">Producto</p>
          <ul className="space-y-2.5 font-body-landing text-sm text-bone/50">
            <li><a href="#funcionalidades" className="hover:text-bone transition-colors">Funcionalidades</a></li>
            <li><a href="#precios" className="hover:text-bone transition-colors">Precios</a></li>
            <li><a href="#comparativa" className="hover:text-bone transition-colors">Comparativa</a></li>
            <li><a href="#faq" className="hover:text-bone transition-colors">Preguntas frecuentes</a></li>
            <li><Link to="/registro" className="hover:text-bone transition-colors">Prueba gratis</Link></li>
          </ul>
        </div>
        <div>
          <p className="font-body-landing font-bold text-bone/80 text-sm mb-4">Acceso</p>
          <ul className="space-y-2.5 font-body-landing text-sm text-bone/50">
            <li><Link to="/admin/login" className="hover:text-bone transition-colors" data-testid="footer-admin-link">Panel de administración</Link></li>
            <li><Link to="/kiosko" className="hover:text-bone transition-colors" data-testid="footer-kiosk-link">Kiosko de fichaje (tablet)</Link></li>
            <li><Link to="/app" className="hover:text-bone transition-colors" data-testid="footer-app-link">App del empleado</Link></li>
          </ul>
        </div>
      </div>

      <p className="font-display font-black text-bone/5 text-[16vw] leading-none select-none whitespace-nowrap -mb-6" aria-hidden="true">
        GestionaEmpleados
      </p>
      <p className="font-body-landing text-xs text-bone/40 border-t border-bone/10 pt-6">
        © {new Date().getFullYear()} GestionaEmpleados · Registro de jornada conforme al RDL 8/2019 y preparado para la nueva normativa 2026
      </p>
    </div>
  </footer>
);
